function Logo() {
	return (
		<span className="col-4 text-white figtree text-left">
			<span style={{ color: "#FF6B6B", fontStyle: "italic" }}>T</span>
			<span style={{ fontStyle: "italic" }}>umbo</span>
			<span style={{ color: "#4EC9B7", fontStyle: "italic" }}>D</span>
			<span style={{ fontStyle: "italic" }}>ash</span>
		</span>
	);
}

export default Logo;
